<template>
  <div class="wrap"
       :style="{'background':list.lives_will.length<1&&list.lives_ed.length<1&&list.lives_ing.length<1?'#FFFFFF':''}">
    <div class="banner">
      <i-banner :list="imgList"
                :height="4.21"></i-banner>
    </div>
    <menuBar :type="'live'" @menuBar="menuBar"></menuBar>
    <div class="title_type"
         v-show="liveList.length">
      <div @click="toMore('new')">
        <span>更多</span>
        <img src="../../assets/images/more.png"
             alt="">
      </div>
    </div>
    <div class="container"
         v-if="list">
      <div class="container_item"
           v-for="(item,index) in liveList"
           v-show="item.lFl==1"
           :key="'liveswill'+index">
        <p class="item_title">
          <span class="title_name">
            <span>{{item.group.egName}}</span>
          </span>
          <span class="title_time">{{getTimes(item.lDt)}}</span>
        </p>

        <div class="con"
             @click="toDetails(item.lId)"
             style="border-bottom: 1px solid #e6e6e6;">
          <div style="position: relative;">
            <div v-if="checkUserMember">
              <get-vip-img v-if="item.lIsvipfree==1"></get-vip-img>
            </div>

            <img class="con_images"
               :src="item.lPicUrl"
               alt
               v-if="item.lPicUrl" />
            <img class="con_images"
                src="../../assets/images/default.png"
                alt
                v-else />
          </div>

          <div class="con_right">
            <p class="con_title">{{item.lTitle}}</p>
              <div class="con_div">
                <p   class="con_author">{{item.lSpeaker}}</p>
                <p v-if="isShowCount"  class="con_author_red">{{item.lViewCount}}人观看</p>
              </div>

              <p class="con_org">{{item.lOrg}}</p>

          </div>

        </div>
        <div class="last"
             v-show="menuBarId==2">
          <span>预约人数：{{item.lAppointNum}}人</span>
          <button class="footer_yybm"
                  @click="signUp(item.lIsAppoint,index,item.lId)"
                  :style="{background:item.lIsAppoint==1?'#999999':'linear-gradient(0deg,rgba(9,131,255,1) 0%,rgba(33,175,255,1) 100%)'}">{{item.lIsAppoint==1?'已预约':'预约报名'}}</button>
        </div>
      </div>
      <div v-if="liveList.length<1"
           class="nothing">
        <img src="../../assets/images/nonelist.png"
             alt />
        <div>暂无直播</div>
      </div>
    </div>
    <!-- <filterBnt @filterBnt="filter"></filterBnt>
    <filterResult @reset="filterResultReset"
                  @sure="filterResultSure"
                  v-show="filterResultVib"></filterResult> -->
  </div>
</template>
<script>
import iBanner from "../container/banner";
import weui from "weui.js";
import menuBar from "../container/menu";
import filterBnt from "../container/filterBnt";
import filterResult from "../container/filterResult";
import GetVipImg from '../getvipimg/getVipImg.vue';
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  components: {
    iBanner,
    menuBar,
    filterBnt,
    filterResult,
    GetVipImg
  },
  data () {
    return {
      isShowCount:false,
      checkUserMember:true,
      imgList: [],
      liveList: [],
      filterResultVib: false,
      menuBarId: "",
      list: {
        lives_will: [],
        lives_ing: [],
        lives_ed: []
      },
      lives_ing: [],
      lives_will: [],
      lives_ed: [],
      uid: "",
      ra_wxUser: null
    };
  },
  props: {},
  created () {
    this.$waiting.show(3);
  },

  methods: {

    getUser(){
      let type = this.ra_wxUser ? this.ra_wxUser.uMemberType : 0;
      if(type == 1 || type ==2){
        //this.checkUserMember = true;
      }
    },
    toMore (type) {
      this.$router.push({
        name: "Testlist",

      });
    },

    menuBar (val) {
      this.menuBarId = val;
      if (val == 1) {
        this.liveList = this.list.lives_ing;
        this.isShowCount = false;
      } else if (val == 2) {
        this.liveList = this.list.lives_will;
        this.isShowCount = false;
      } else if (val == 3) {
        this.liveList = this.list.lives_ed;
        this.isShowCount = true;
      }
    },
    filter () {
      this.filterResultVib = true;
    },
    filterResultReset () {
      this.filterResultVib = false;
    },
    filterResultSure (res) {
      console.log(res);
      let params = {
        title: "",
        type: "",
        order: res.egId,
        ccId: res.ccId,
        lId: res.lId
      };
      this.$router.push({
        name: "Testlist",
      });
    },
    getData () {
      let uid = ''
      if (this.ra_wxUser && this.ra_wxUser.uId) {
        uid = this.ra_wxUser.uId
      }
      
      var param = {
        uid: uid,
        eg_ids: [],
        buy_uid: uid
      };
      this.$postHttp(AppSetting.baseUrl + "/live/student/list", param).then(res => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;
          this.liveList = data.lives_ing;
          // this.sing = data.lives_will.lIsAppoint==1?1:0;
          // alert(this.sing)
          // this.text = data.lives_will.lIsAppoint==1?'已预约':'预约报名';
          // this.lives_ing = data.lives_ing;


          this.imgList = data.pictures;


          // this.lives_will = data.lives_will;
          // this.lives_ed = data.lives_ed;
          if (this.menuBarId == 1) {
            this.liveList = this.list.lives_ing;
          } else if (this.menuBarId == 2) {
            this.liveList = this.list.lives_will;
          } else if (this.menuBarId == 3) {
            this.liveList = this.list.lives_ed;
          }
        }
      });
    },
    getTimes (value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails (id) {
      this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id }
      });
    },
    async signUp (status, index, lid) {
      this.ra_wxUser=await loginService.getLoginUser();
      if(!this.ra_wxUser)
      {
         loginService.login(this.$router)
         .then(loginUser=>{
            this.ra_wxUser = loginUser;
            console.log("微信用户信息-->", loginUser);
            this.getData();
         })
      } else {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser
              ? this.ra_wxUser.uId
                ? this.ra_wxUser.uId
                : ""
              : "",
            lid: lid
          }).then(res => {
            if (res.data.code == 0) {
              // this.text = '已预约';
              // this.sing = 1;
              // this.list.lives_will[index].lIsAppoint.$set()
              this.$set(this.list.lives_will[index], "lIsAppoint", 1);
              this.$set(
                this.list.lives_will[index],
                "lAppointNum",
                res.data.num
              );
              //参数：要改的对象、要改的key 、要改的值
              this.$toast.success("预约成功");
            } else {
              this.topTips("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: res => {
                  // alert('取消')
                }
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser
                      ? this.ra_wxUser.uId
                        ? this.ra_wxUser.uId
                        : ""
                      : "",
                    lid: lid
                  }).then(res => {
                    if (res.data.code == 0) {
                      this.$set(this.list.lives_will[index], "lIsAppoint", 0);
                      this.$set(
                        this.list.lives_will[index],
                        "lAppointNum",
                        res.data.num
                      );
                      this.$toast.success("取消成功");
                    } else {
                      this.topTips("取消预约失败");
                    }
                  });
                }
              }
            ]
          });
        }
      }
    },
  },
  async mounted () {
    this.ra_wxUser= await loginService.getLoginUser();

    document.title = "直播";
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      sessionStorage.setItem("pro", "ra");
      this.getData();
      this.getUser();
  },
  activated () {

    if (this.$route.meta.keepAliveChange) {
      this.getData();


    }

  }
};
</script>
<style scoped lang="scss">

.wrap {
  background: #f4f5f4;
  min-height: 100vh;
}
.nothing {
  background: #ffffff;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  img {
    width: 100%;
    display: inline-block;
  }
  div {
    font-size: 0.36rem;
    color: #47acff;
    text-align: center;
  }
  width: 100%;
}
.banner {
  width: 7.5rem;
}
.container {
  margin-bottom: 0.98rem;
  // overflow: auto;
  .container_item {
    background: #ffffff;
    margin-bottom: 0.21rem;
    //padding-left: 0.3rem;
    padding: 0 0.26rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    .item_title {
      //padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.03rem;
      .title_name {
        font-size: 0.26rem;
        color: #666666;
        width: 4.2rem;
        overflow: hidden;

        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;
      .con_right {
        /*height: 1.62rem;*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }
      .con_title {
        //width: 3.83rem;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.36rem;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }
    .con_author {
      /*margin-top: 0.68rem;*/
      color: #666;
      font-size: 0.24rem;
    }
    .con_author_red {
      /*margin-top: 0.68rem;*/
      color:red;
      font-size: 0.24rem;
    }

    .con_org {
      font-size: 0.26rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
    }
  }

  .type_title {
    padding-left: 0.33rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 0.2rem;
  }
  .last {
    span:nth-of-type(1) {
      font-size: 0.26rem;
    }
  }
  .last,
  .type_title {
    display: flex;
    height: 0.8rem;
    justify-content: space-between;
    padding-right: 0.29rem;
    align-items: center;
    background: #ffffff;
    button {
      width: 1.4rem;
      height: 0.5rem;
      background: linear-gradient(
        0deg,
        rgba(9, 131, 255, 1) 0%,
        rgba(33, 175, 255, 1) 100%
      );
      border-radius: 25px;
      font-size: 0.26rem;
      color: #ffffff;
      border: none;
      outline: none;
    }
  }
  .footer_type {
    font-size: 0.26rem;
    color: #ffb400;
  }
  .textColor {
    color: #2bcf4a;
  }
  .live_type {
    font-size: 0.34rem;
    font-weight: bold;
    color: #007eff;
  }
}
.title_type {
  display: flex;
  align-items: center;
  height: 0.35rem;
  margin-top: 0.1rem;
  margin-right: 0.2rem;

  justify-content: flex-end;
  margin-bottom: 0.1rem;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.24rem;
      color: #1b94f5;
    }
  }
  > span:nth-of-type(1) {
    color: #1b94f5;
    font-size: 0.36rem;
    font-weight: bold;
  }
  img {
    width: 0.25rem;
    height: 0.25rem;
    margin-left: 0.07rem;
  }
}
.con_div{
  display:flex;
   flex-wrap: nowrap;
   //width:200px;
   justify-content:space-between;

}
</style>



// WEBPACK FOOTER //
// src/components/live/index.vue